import {ISegmentControlValueList} from 'components/SegmentedControl';
import {ISocialLinkModel} from 'modules/auth/types';
import Icon from 'components/Icon';

export const MIN_PASSWORD_LENGTH = 6;
export const MIN_NAME_LENGTH = 1;
export const MIN_SURNAME_LENGTH = 1;
export const MIN_PHONE_LENGTH = 10;
export const MAX_PHONE_LENGTH = 14;
export const MAX_PASSWORD_LENGTH = 50;

// Только для того чтобы не ломало AuthUserDoesNotExistModal
export const MAX_EMAIL_LENGTH = 29;

export const NAME_PHRASES = {
    LONG_NAME: 'Имя слишком длинное',
    REQUIRED_NAME: 'Введите имя',
    SHORT_NAME: 'Имя слишком короткое',
};

export const SURNAME_PHRASES = {
    LONG_SURNAME: 'Фамилия слишком длинная',
    REQUIRED_SURNAME: 'Введите фамилию',
    SHORT_SURNAME: 'Фамилия слишком короткая',
};

export const BIRTHDATE_PHRASES = {
    REQUIRED_BIRTHDATE: 'Введите дату рождения',
};

export const GENDER_PHRASES = {
    REQUIRED_GENDER: 'Выберите пол',
};

export const PHONE_PHRASES = {
    LONG_PHONE: 'Номер телефона слишком длинный',
    REQUIRED_PHONE: 'Пожалуйста, введите номер телефона',
    SHORT_PHONE: 'Номер телефона слишком короткий',
    TYPE_ERROR: 'Номер телефона должен быть числом',
    CORRECT_PHONE: 'Пожалуйста, введите корректный номер телефона',
};

export const EMAIL_PHRASES = {
    INCORRECT_EMAIL: 'Пожалуйста, введите корректный e-mail',
    REQUIRED_EMAIL: 'Введите ваш email',
};

export const EMAIL_AND_PHONE_PHRASES = {
    INCORRECT_EMAIL_AND_PHONE: 'Введён некорректный номер телефона или email адрес',
    REQUIRED_EMAIL_AND_PHONE: 'Пожалуйста, введите номер телефона или email',
    SHORT_EMAIL_AND_PHONE: 'Слишком короткий email или номер телефона',
};

export const PASSWORD_PHRASES = {
    LONG_PASSWORD: 'Пароль слишком длинный',
    REQUIRED_PASSWORD: 'Пожалуйста, введите пароль',
    SHORT_PASSWORD: 'Пароль не может быть короче 6 символов',
};

export const CODE_PHRASES = {
    REQUIRED_CODE: 'Пожалуйста, введите код',
    REQUIRED_CODE_EMAIL: 'Укажите код из e-mail',
    REQUIRED_CODE_SMS: 'Укажите код из SMS',
};

export const SMS_TAB: ISegmentControlValueList = {
    id: 1,
    label: 'Вход по СМС',
    value: 'sms',
};

export const AUTH_ERROR_CODES = {
    ERROR_AUTH: 'errorAuth',
    EXCEPTION: 'exception',
    LIMIT_ATTEMPT: 'limitAttempt',
    MANY_REQUESTS: 'manyRequests',
    USER_NOT_FOUND: 'USER_NOT_FOUND',
};

export const SOCIAL_LINKS: ISocialLinkModel[] = [
    {icon: <Icon icon={'vk-logo'} />, name: 'vk'},
    {icon: <Icon icon={'classmates-logo'} />, name: 'ok'},
    {icon: <Icon icon={'yandex-logo'} />, name: 'yandex'},
    {icon: <Icon icon={'mail-ru-logo'} />, name: 'mail'},
    {icon: <Icon icon={'google-logo'} />, name: 'google'},
];

export const VIEW_CONTENT_NAME = {
    authByEmail: 'authByEmail',
    authByPhone: 'authByPhone',
    authForm: 'authForm',
    codeConfirmEmail: 'codeConfirmEmail',
    codeConfirmRecovery: 'codeConfirmRecovery',
    codeConfirmSms: 'codeConfirmSms',
    createPassword: 'createPassword',
    emailCodeConfirm: 'emailCodeConfirm',
    emailStep: 'emailStep',
    passwordRecovery: 'passwordRecovery',
    registration: 'registration',
    updatePhone: 'updatePhone',
    userEnterBlock: 'userEnterBlock',
    userNotExist: 'userNotExist',
    userAlreadyExistsEmail: 'userAlreadyExistsEmail',
    bindPhoneStep: 'bindPhoneStep',
} as const;

export const errorMessages = {
    incorrectDate: 'Введите дату рождения в формате дд.мм.гггг',
    incorrectEmail: 'Некорректный email',
    incorrectPhone: 'Пожалуйста, введите корректный номер телефона',
    minAge: 'Мы не продаём алкоголь лицам младше 18 лет',
    required: 'Пожалуйста, введите номер телефона или e-mail',
};

export const TOKEN_NAME = 'token';
